import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPhone(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="m6.611 4.579-.235-.801A1.78 1.78 0 0 0 4.668 2.5h-.197c-1.092 0-2.002.884-1.82 1.962a10.82 10.82 0 0 0 5.254 7.582 10.7 10.7 0 0 0 3.604 1.291c1.09.184 1.991-.732 1.991-1.837 0-.887-.585-1.67-1.436-1.92l-.643-.19a1.3 1.3 0 0 0-1.3.346c-.392.41-1.011.524-1.488.215a8.7 8.7 0 0 1-2.582-2.582c-.309-.477-.194-1.096.215-1.489.348-.335.482-.836.345-1.3Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPhone);
export default ForwardRef;
